import React from "react";
import {
  Button,
  Center,
  Box,
  VStack,
  Text,
  Heading,
  Container,
} from "@chakra-ui/react";
import useTranslate from "hooks/useTranslate";
import { useConnect } from "wagmi";
import Logo from "components/Logo";
import useSnackbarError from "hooks/useSnackbarError";

const ConnectPage: React.FC = () => {
  const translate = useTranslate();

  const [{ data: connectData, error }, connect] = useConnect();
  useSnackbarError(error);

  return (
    <Container flexGrow="1">
      <Center h="full" pt="12" pb="16">
        <VStack w="full" h="full" maxH="xl" maxW="sm" align="center" gap="8">
          <Box as={Logo} w="40" h="auto" flexShrink="0" />

          <Center flexDir="column" textAlign="center" flexGrow="1">
            <Heading as="h1" fontSize="7xl" fontWeight="800" lineHeight="none">
              $HONEY
              <Text as="span" fontSize="5xl" display="block">
                REVOLUTION
              </Text>
            </Heading>
          </Center>

          <VStack w="full" align="stretch" spacing="4" flexShrink="0">
            {connectData.connectors.map((connector) => (
              <Button
                key={connector.id}
                onClick={() => connect(connector)}
                isDisabled={!connector.ready}
                size="lg"
              >
                {translate("connect:button:label", {
                  connector:
                    connector.name === "Injected" ? "MetaMask" : connector.name,
                })}
              </Button>
            ))}
          </VStack>
        </VStack>
      </Center>
    </Container>
  );
};

export default ConnectPage;
